import axios from "axios";

import {
    apiErrorHandler,
    SessionExpiredHandler,
} from "src/util/commonFunction";

import { apis } from "../configAPI.json";
import Cookies from "js-cookie";



export const getAllConfigList = async () => {
    try {
        axios.defaults.headers.common["authorization"] = Cookies.get("token");
        var requestOptions = {
            method: "post",
            url: `${apis.BaseApi2}/iotDevice/getconfiglist`,
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await axios(requestOptions);
        if (
            response &&
            response.data &&
            response.data.statusText === "Unauthorized!"
        ) {
            SessionExpiredHandler();
        } else {
            let res = await response;
            return res;
        }
    } catch (e) {
        apiErrorHandler(e);
        return e;
    }
};


export const getConfigPropertyList = async () => {
    try {
        axios.defaults.headers.common["authorization"] = Cookies.get("token");
        var requestOptions = {
            method: "get",
            url: `${apis.BaseApi2}/iotDevice/configproperty`,
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await axios(requestOptions);
        if (
            response &&
            response.data &&
            response.data.statusText === "Unauthorized!"
        ) {
            SessionExpiredHandler();
        } else {
            let res = await response;
            return res;
        }
    } catch (e) {
        apiErrorHandler(e);
        return e;
    }
};


export const updateConfig = async (data) => {
    try {
        axios.defaults.headers.common["authorization"] = Cookies.get("token");
        const jsonData = data.JSON && Object.keys(data.JSON).length > 0 ? JSON.stringify(data.JSON) : null;

        var requestOptions = {
            method: "post",
            url: `${apis.BaseApi2}/iotDevice/configedit`,
            headers: {
                "Content-Type": "application/json",
            },
            data: { JSON: jsonData, configId: data.configId, name: data.name }
        };
        const response = await axios(requestOptions);
        if (
            response &&
            response.data &&
            response.data.statusText === "Unauthorized!"
        ) {
            SessionExpiredHandler();
        } else {
            let res = await response;
            return res;
        }
    } catch (e) {
        apiErrorHandler(e);
        return e;
    }
};


export const deleteConfig = async (id) => {
    try {
        axios.defaults.headers.common["authorization"] = Cookies.get("token");
        var requestOptions = {
            method: "post",
            url: `${apis.BaseApi2}/iotDevice/configdelete`,
            headers: {
                "Content-Type": "application/json",
            },
            data: { configId: id }
        };
        const response = await axios(requestOptions);
        if (
            response &&
            response.data &&
            response.data.statusText === "Unauthorized!"
        ) {
            SessionExpiredHandler();
        } else {
            let res = await response;
            return res;
        }
    } catch (e) {
        apiErrorHandler(e);
        return e;
    }
};

export const getOperatingMode = async () => {
    try {
        axios.defaults.headers.common["authorization"] = Cookies.get("token");
        var requestOptions = {
            method: "get",
            url: `${apis.BaseApi2}/config/operating-mode`,
            headers: {
                "Content-Type": "application/json",
            },
        };
        const response = await axios(requestOptions);
        
        // Check for unauthorized response - treat as failure instead of triggering session expiration
        if (
            response &&
            response.data &&
            response.data.statusText === "Unauthorized!"
        ) {
            console.warn("Operating mode API returned unauthorized - using fallback mode");
            throw new Error("Unauthorized response from operating mode API");
        } 
        
        // Check for valid response structure with the new format
        if (response && response.data) {
            // Check if the API returned an error status
            if (response.data.status === false) {
                console.warn("Operating mode API returned error status:", response.data.message);
                throw new Error(`API error: ${response.data.message || 'Unknown error'}`);
            }
            
            // Check for successful response with mode data
            if (response.data.status === true && response.data.data && response.data.data.mode) {
                return response;
            } else {
                console.warn("Operating mode API returned unexpected response structure:", response.data);
                throw new Error("Invalid response structure from operating mode API");
            }
        } else {
            console.warn("Operating mode API returned no data:", response);
            throw new Error("No data received from operating mode API");
        }
    } catch (e) {
        console.error("Operating mode API call failed:", e.message || e);
        // Don't call apiErrorHandler for operating mode failures - let the context handle fallback
        throw e;
    }
};
